<template>
    <input
        :id="question.label"
        v-model="value"
        type="text"
        class="form-control"
        :placeholder="question.placeholder"
    />
</template>

<script>
export default {
    props: {
        question: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            value: ''
        };
    },

    watch: {
        value(value) {
            this.$emit('input', value);
        }
    },

    created() {
        this.value = this.question.answer;
    }
};
</script>
